// Normaliza un correo: trim + lowercase
export const normalizaEmail = (s: string) => s.trim().toLowerCase();

// RFC 5322-lite (el mismo que usabas)
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
